import React, { useRef, useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const HomeDevelopers = () => {
    const [categories, setCategories] = useState([]);
    const navigate = useNavigate();
    const carouselRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const updateScrollButtons = () => {
        const container = carouselRef.current;
        if (!container) return;
        setCanScrollLeft(container.scrollLeft > 0);
        setCanScrollRight(container.scrollLeft + container.clientWidth < container.scrollWidth - 1);
    };

    const scroll = (direction) => {
        const container = carouselRef.current;
        if (!container) return;
        const scrollAmount = 300;
        container.scrollBy({
            left: direction === 'left' ? -scrollAmount : scrollAmount,
            behavior: 'smooth',
        });
    };

    const parseArray = (input) => {
        if (Array.isArray(input)) return input;
        if (typeof input === "string") {
            try {
                return JSON.parse(input);
            } catch {
                return [];
            }
        }
        return [];
    };

    const fetchData = async () => {
        try {
            const response = await fetch(`https://100real.xyz/categoryfeaturedev/getcategory/HBTR0003`);
            let res = await response.json();

            res = res.filter((category) => category.status === "Active");

            res = res.map((category) => {
                let buildings = [];
                try {
                    buildings = JSON.parse(category.buildings || "[]").map((building) => ({
                        ...building,
                        amenities: parseArray(building.amenities),
                        flatType: parseArray(building.flatType),
                        formImages: parseArray(building.formImages),
                        locationAdvantages: parseArray(building.locationAdvantage || building.locationAdvantages),
                        security: parseArray(building.security),
                        water_supply: parseArray(building.water_supply),
                    }));
                } catch (err) {
                    console.error("Error parsing buildings:", err);
                }

                return {
                    ...category,
                    buildings,
                };
            });

            const sortedData = res.sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
            setCategories(sortedData);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        const container = carouselRef.current;
        if (!container) return;

        updateScrollButtons();

        container.addEventListener('scroll', updateScrollButtons);
        window.addEventListener('resize', updateScrollButtons);

        return () => {
            container.removeEventListener('scroll', updateScrollButtons);
            window.removeEventListener('resize', updateScrollButtons);
        };
    }, [categories]);

    if (!categories.length) return null;

    return (
        <div className="sarfare-developer-wrapper">
            <h2 className="sarfare-developer-heading">Developers</h2>
            <div className="sarfare-developer-carousel-wrapper">
                {canScrollLeft && (
                    <button className="sarfare-developer-arrow left" onClick={() => scroll('left')}>
                        <ChevronLeft size={24} />
                    </button>
                )}

                <div className="sarfare-developer-carousel" ref={carouselRef}>
                    {categories.map((category, index) => (
                        <div
                            className={`sarfare-developer-card sarfare-developer-${category.category
                                .toLowerCase()
                                .replace(/\s+/g, '-')}`}
                            key={index}
                            onClick={() => navigate(`/projects/${category._id}`)}
                        >
                            <img
                                src={`https://100real.xyz/${category.image_logo}`}
                                alt={category.category}
                                className="sarfare-developer-image"
                            />
                            <h3 className="sarfare-developer-title">{category.category}</h3>
                            <p className="sarfare-developer-properties">{category.buildings.length} Properties</p>
                        </div>
                    ))}
                </div>

                {canScrollRight && (
                    <button className="sarfare-developer-arrow right" onClick={() => scroll('right')}>
                        <ChevronRight size={24} />
                    </button>
                )}
            </div>
        </div>
    );
};

export default HomeDevelopers;
